

/** 默认列表字段 */
export const DefaultListFeilds = {

    /** 模板编号 */
    id: 'id',

    /** 模板名称 */
    name: 'templateName',

    /** 备注 */
    remark: 'remark',

    /** 条件 */
    condition: 'queryCriteriaStr',

    /** 更新时间 */
    updateTime: 'gmtModified',

};

/** 详情页面字段 */
export const DefaultDetailFields = {

    /** 条件 */
    condition: 'condition',

    /** 必填项 */
    required: 'required',

    /** 类型 */
    type: 'type',

    /** 用途 */
    purpose: 'useGoal',
};
